export interface JwtPayload {
  readonly sub?: string;
  readonly exp?: number;
  readonly iat?: number;
  readonly [claim: string]: unknown;
}

/** Decodes the payload WITHOUT verifying the signature. Never use it for authorization — the API decides. */
export function decodeJwt(token: string): JwtPayload | null {
  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    return JSON.parse(atob(padded)) as JwtPayload;
  } catch {
    return null;
  }
}

/** A token is usable when it decodes and its `exp` (if present) is in the future, with a small clock-skew margin. */
export function isJwtUsable(token: string | null, skewSeconds = 30, now = Date.now()): boolean {
  if (!token) {
    return false;
  }
  const payload = decodeJwt(token);
  if (!payload) {
    return false;
  }
  return typeof payload.exp !== 'number' || payload.exp * 1000 - skewSeconds * 1000 > now;
}
